import { DetailedHTMLProps, FC, InputHTMLAttributes } from "react";
import styles from "./index.module.scss";


interface IProps extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string
  validationMessage?: string
  inputClassName?: string
}


const Input: FC<IProps> = ({
  label,
  className = "",
  validationMessage,
  inputClassName,
  ...rest
}) => {
  return (
    <div className={styles.input + ` ${className}`}>
      <label className={styles.label__input}>
        {label ? <h4>{rest.required && <span className={styles.required__label}>*</span>} {label}: </h4> : ""}
        <input
          className={styles.input__label + ` ${inputClassName ?? ""}`}
          {...rest}
        />

        {
          // validationMessage &&
          <p className={styles.validation__label}>{validationMessage}</p>
        }
      </label>
    </div>
  );
}

export default Input